<template>
  <div class="dashboard-container p-3">
    <h4 class="mb-3">Dashboard</h4>
    <b-row>
      <b-col cols="12" md="3">
        <SummaryCard title="Total Donations" :value="summary.total_donations" />
      </b-col>
      <b-col cols="12" md="3">
        <SummaryCard title="Total Transplants" :value="summary.total_transplants" />
      </b-col>
      <b-col cols="12" md="3">
        <SummaryCard title="Active Waitlist" :value="summary.active_waitlist" />
      </b-col>
      <b-col cols="12" md="3">
        <SummaryCard title="Registered Hospitals" :value="summary.registered_hospitals" />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" md="6">
        <DonationChart :data="monthlyDonations" />
      </b-col>
      <b-col cols="12" md="6">
        <WaitlistChart :data="waitlistByOrgan" />
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <HospitalChart :data="hospitalTransplants" />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import SummaryCard from "../components/dashboard/SummaryCard.vue";
import DonationChart from "../components/dashboard/DonationChart.vue";
import WaitlistChart from "../components/dashboard/WaitlistChart.vue";
import HospitalChart from "../components/dashboard/HospitalChart.vue";
import statisticsService from "../assets/services/statistics.service";

export default {
  components: {
    SummaryCard,
    DonationChart,
    WaitlistChart,
    HospitalChart,
  },
  data() {
    return {
      summary: {
        total_donations: 0,
        total_transplants: 0,
        active_waitlist: 0,
        registered_hospitals: 0,
      },
      monthlyDonations: [],
      waitlistByOrgan: [],
      hospitalTransplants: [],
    };
  },
  methods: {
    async loadDashboard() {
      try {
        this.$loader.show();
        const { data } = await statisticsService.getDashboardStatistics();
        if (data.status) {
          if (data.summary) {
            this.summary = data.summary;
          }
          if (data.monthly_donations) {
            this.monthlyDonations = data.monthly_donations;
          }
          if (data.waitlist_by_organ) {
            this.waitlistByOrgan = data.waitlist_by_organ;
          }
          if (data.hospital_transplants) {
            this.hospitalTransplants = data.hospital_transplants;
          }
        }
        this.$loader.hide();
      } catch (error) {
        this.$loader.hide();
      }
    },
  },
  mounted() {
    this.loadDashboard();
  },
};
</script>

<style scoped>
.dashboard-container {
  max-width: 1400px;
  margin: 0 auto;
}
</style>
